import app from './app-saga';
import auth from './auth-saga';
import providers from './provider-saga';
import serviceLocations from './service-location-saga';
import serviceTypes from './service-type-saga';
import emailsLog from './emails-log-saga';
import vendor from './vendor-saga';
import district from './district-saga';
import student from './student-saga';
import order from './order-saga';
import caseEnt from './case-saga';
import seance from './seance-saga';
import invoice from './invoice-saga';
import contract from './contract-saga';
import substitution from './substitution-saga';
import payment from './payment-saga';
import credit from './credit-saga';
import adminWork from './adminWork-saga';
import programBookDownload from './programBookDownload-saga';
import internal from './internal-saga';
import intakeSent from './intakeSent-saga';
import reportPayroll from './reportPayroll-saga';
import deduction from './deduction-saga';
import caseNoConsent from './caseNoConsent-saga';
import caseNoPrincipal from './caseNoPrincipal-saga';
import providerReport from './providerReport-saga';
import seanceReport from './seanceReport-saga';
import orderRemainingHoursReport from './orderRemainingHoursReport-saga';
import workedHoursReport from './workedHoursReport-saga';
import nonBilledSessionsReport from './nonBilledSessionsReport-saga';
import orderExpiredReport from './orderExpiredReport-saga';
import programBook from './programBook-saga';

import expense from './expense-saga';
import incentive from './incentive-saga';
import payroll from './payroll-saga';
import wage from './wage-saga';
import bonusSaga from './bonus-saga';

export default [
    app,
    auth,
    orderRemainingHoursReport,
    workedHoursReport,
    nonBilledSessionsReport,
    orderExpiredReport,
    providerReport,
    seanceReport,
    caseNoConsent,
    caseNoPrincipal,
    reportPayroll,
    deduction,
    wage,
    payroll,
    incentive,
    expense,
    internal,
    adminWork,
    programBookDownload,
    bonusSaga,
    substitution,
    serviceTypes,
    serviceLocations,
    providers,
    emailsLog,
    vendor,
    district,
    invoice,
    contract,
    order,
    seance,
    student,
    caseEnt,
    credit,
    payment,
    programBook,
    intakeSent,
];
